const initialState = {
	isLoading: 0,
	hasError: 0
};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//  GET
		// ===================================
		case "NEWS_ARE_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "NEWS_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				hasError: 1,
				error: action.error
			};
		case "NEWS_SUCCESS":
			return {
				...state,
				news: action.data.data,
				isLoading: 0
			};

		// ===================================
		//  CLEAR
		// ===================================
		case "NEWS_CLEAR":
			return {};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/news.js